define([
	"dojo/_base/declare",
	"ProductSpec/SizeChart/SewnGarmentActual"
], function(declare,SewnGarmentActual) {

	return declare(SewnGarmentActual, {
		highlightSetting: "sizeChartHighlightDeltaOutOfTolerance",

		_getSewnGarmentActual: function(/*Context*/ctx) {
			// summary: return actual value
			return ctx.getNode().SewnGarmentActuals[ctx.keyValue];
		},

		_getDiff: function(/*Number*/value, /*Number*/target) {
			// summary: return value since it is already the difference
			return value;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return difference between actual and target value
			var	value = this._getSewnGarmentActual(ctx);
			return (value == this.DEFAULT) ? value : this._gap(value, this._getPatternWithShrinkage(ctx));
		}
	});
});